export default __webpack_public_path__ + "static/media/gameDefault.961fec0d.png";